




























import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {User} from '@/models';

const Auth = namespace('Auth');
import {LoginDto} from '@/services/LoginModels';
import {loginService} from '@/services/login.service';

@Component
export default class SignOut extends Vue {
  @Auth.Getter
  public loginUser!: User;
  @Auth.Action
  public signOut!: () => void;
  private userId = '';
  private text = '○ 핀크스 회원탈퇴 유의사항1 \n○ 핀크스 회원탈퇴 유의사항2';

  userLeave(): void {
    loginService.userIdFind(this.loginUser).then(response => {
      if (response.status == 200) {
        const responseData = response.data;
        if (responseData.resultCode == '0000') {
          this.userId = responseData.obj.userId;
          this.userLeaveConfirm();
        } else {
          this.$bvModal
            .msgBoxOk('아이디 검색안됨', {
              title: '오류발생',
              okVariant: 'danger',
              centered: true,
            })
            .then(value => {
              this.userId = '';
            });
        }
      } else {
        //http response 오류 처리
      }
    });
  }

  userLeaveConfirm(): void {
    this.$bvModal
      .msgBoxConfirm('정말로 회원을 탈퇴하시겠습니까?', {
        title: '회원탈퇴',
        okVariant: 'danger',
        centered: true,
      })
      .then(value => {
        if (value === true) {
          loginService.userLeave(this.loginUser, this.userId).then(response => {
            if (response.status == 200) {
              const responseData = response.data;
              if (responseData.resultCode == '0000') {
                this.$bvModal
                  .msgBoxOk('정상적으로 회원탈퇴를 완료하였습니다', {
                    title: '성공',
                    okVariant: 'success',
                    centered: true,
                  })
                  .then(value => {
                    this.signOut();
                    this.$router.push('/');
                  });
              } else {
                this.$bvModal.msgBoxOk('회원탈퇴 실패', {
                  title: '오류발생',
                  okVariant: 'danger',
                  centered: true,
                });
              }
            } else {
              //http response 오류 처리
            }
          });
        }
      });
  }
}
